import {Switch, Toast} from 'antd-mobile'
import {useEffect, useState} from "react";
import JsonRequest from "../../../request/json_request";
import {flutterUser} from "../../../util";
import ArrowDown from "../../../images/arrow-down.png";
import "./index.css";

export default ({totalSignInCount, rewardConfig, signInCount}) => {
    const client = JsonRequest.headerClient(flutterUser);
    const [remindStatus, setRemindStatus] = useState(false);
    const signInEventKey = "acupoint:coin:event::clock-in-continuous";
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        getRemindStatus();
    }, []);

    const getRemindStatus = () => {
        client.get(`/api/std/app/v2/share/coin/remind/${signInEventKey}/status`)
            .then(resp => resp.json())
            .then(({data}) => {
                setRemindStatus(data?.enable)
            })
    }

    const toggleRemindStatus = async (check, toast = true) => {
        await client.get(`/api/std/app/v2/share/coin/remind/${signInEventKey}/toggle`, {enable: check})
            .then(resp => resp.json())
        setRemindStatus(check)
        if (check && toast)
            Toast.show({content: '系统将在每日10点提醒', position: 'top'})
    }

    const SignInItem = ({index, value}) => {
        const className = index + 1 < signInCount ? 'sign-in-bg-last' : index + 1 === signInCount ? 'sign-in-bg-current' : 'sign-in-bg-next';
        return <div className='sign-in-item'>
            <div className={`sign-in-item-body ${className}`}>
                <span>{index + 1 < signInCount ? '已领' : `+${value}`}</span>
            </div>
            <span className='sign-in-sub-text'>{index + 1 === signInCount ? '今天' : `第${index + 1}天`}</span>
        </div>
    }

    const SignInList = () => {
        if (!expanded) {
            const list = [];
            const startIndex = parseInt((signInCount - 1) / 7) * 7 + 1;
            const length = Object.keys(rewardConfig).length;
            const endIndex = startIndex + 6 >= length ? length : startIndex + 6;
            for (let i = startIndex; i <= endIndex; i++)
                list.push(<SignInItem key={i} index={i - 1} value={rewardConfig[i]}/>);
            return list;
        }
        return Object.keys(rewardConfig).map((e, i) =>
            <SignInItem key={e} index={i} value={rewardConfig[e]}/>);
    }

    return (<div className='sign-in-box'>
        <div className='flex-space-between'>
            <span className='sign-in-text'>已连续签到<span>{totalSignInCount}</span>天</span>
            <div className='flex-center'>
                <span className='sign-in-sub-text'>签到提醒</span>
                <Switch className='sign-in-notify-switch' checked={remindStatus}
                        onChange={toggleRemindStatus}
                        style={{'--checked-color': '#BC4227', '--width': '30px', '--height': '16px'}}/>
            </div>
        </div>
        <div className='sign-in-list'>
            {rewardConfig && <SignInList/>}
        </div>
        <div className='box-expand flex-center' onClick={() => setExpanded(!expanded)}>
            <img src={ArrowDown} alt="" style={{transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)'}}/>
        </div>
    </div>)
}